import { useContext } from "react";
import { ContextStorage } from "../Storage/ContextStorage";
import { storage, ref, getDownloadURL } from "../../Firebase";


const ProjectDisplay = (props) => {

    const { scroll } = props;
    const { setProjectDisplay, projectObj, setProjectObj } = useContext(ContextStorage);

    const handleDownload = async () => {
        const file = ref(storage, projectObj.downloadURL);
        try {
            getDownloadURL(file).then((url) => {
                const link = document.createElement('a');
                link.href = url;
                link.download = projectObj.downloadURL.split('/').pop();
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
        } catch (error) {
            console.error("Error downloading file:", error);
            alert("Sorry, there was an error downloading the file. Please try again later.");
        }
    };

    return (
        <>
            <div className="project-modal">
                <div className="modal-nav">
                    <h2>{projectObj.title}</h2>
                    <button onClick={() => {setProjectDisplay(false); setProjectObj(null); scroll(false)}}>&times;</button>
                </div>
                <div className="modal-content">
                    <div className="modal-media">
                        <img src={projectObj.media} alt={projectObj.title} />
                    </div>
                    <p><strong>Technologies Used:</strong> {projectObj.technologies}</p>
                    <p>{projectObj.description}</p>
                    <div className="download-section">
                        <p>Download ImageConverter.exe</p>
                        <button onClick={handleDownload}>Download</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export { ProjectDisplay }